/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(

        /* webpackChunkName: "partner" */
        '@/modules/links/scenes/links.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.LINKS.LINKS,
    path: 'partner/links'
  }
] as RouteConfig[];
